import React, { FC } from 'react';
import styled from 'styled-components';
import OvPagination from '../atoms/OvPagination';
import { PaginationItem, useMediaQuery } from '@mui/material';
import breakpoints from '../../../design-system/breakpoints';
import { ArrowBack, ArrowForward } from '@mui/icons-material';

interface OvPaginationBarProps {
  total: number;
  limit: number;
  offset: number | null;
  onChange: (event: React.ChangeEvent<unknown>, page: number) => void;
}

const OvPaginationBar: FC<OvPaginationBarProps> = ({
  total,
  limit,
  offset,
  onChange,
}) => {
  const isPhone = useMediaQuery(`(max-width:${breakpoints.sm})`);
  const currentPage = (offset ?? 0) / limit + 1;
  const pageCount = Math.ceil(total / limit);

  if (total <= limit) return null;

  return (
    <PaginationWrapper>
      <OvPagination
        page={currentPage}
        onChange={onChange}
        count={pageCount}
        siblingCount={isPhone ? 0 : 1}
        renderItem={(item) => (
          <PaginationItem
            components={{ previous: ArrowBack, next: ArrowForward }}
            {...item}
          />
        )}
        shape="rounded"
      />
    </PaginationWrapper>
  );
};

export default OvPaginationBar;

const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
`;
